import { createStore }  from 'vuex'
import adminStore       from './modules/admin'
import videosStore     from './modules/videos'
import {clientPlugin}   from './plugins/client'

const VideoStore = createStore({
    modules: {
        admin: adminStore,
        videos: videosStore
    },
    strict: false,
    plugins: [
        clientPlugin
    ],
    preserveState: true
})

export default VideoStore